<template>
    <div name="medicals" class="medicals">
        <span class="title">진료 항목</span>
        <div class="list">
            <div class="department-box" v-for="(info, index) in departments" v-if="info.is_enabled && info.value != 6" :key="`department_${index}`">
                {{ info.name }}
            </div>
        </div>
        <span class="info-text">*대면/비대면 여부에 따라 진료 가능 항목에 차이가 있을 수 있습니다.</span>
    </div>
</template>

<script>
export default {
    name: 'medicals',
    props: ['departments']
}
</script>

<style scoped> 
    .medicals {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 16px;
        border-radius: 6px;
        background: var(--gray-00, #FFF);
        box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
        margin-bottom: 16px;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 16px;
        flex-wrap: wrap;
        gap: 4px;
    }
    .department-box {
        display: flex;
        padding: 5px 8px;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        border-radius: 3px;
        border: 1px solid var(--gray-30-stroke-disabled, #E8EAEE);
        background: var(--Gray-00, #FFF);
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 133.333% */
        margin-top: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/hospital/Medicals.vue